export default __webpack_public_path__ + "static/media/pm.74aa8119.svg";